import {
    SortDirection,
    type SortConfiguration,
} from "~/components/ottopilotDataViewer/sortConfiguration";
import {generateUuid} from "@vesta/global-common-typescript/utilities/utilities";

export const DATA_VIEWER_DEFAULT_SORT_COLUMN_ID = "createdAt";

export function buildDefaultCreatedAtSortConfiguration(): SortConfiguration {
    return {
        revisionId: generateUuid(),
        lineItems: [
            {
                columnId: DATA_VIEWER_DEFAULT_SORT_COLUMN_ID,
                direction: SortDirection.descending,
            },
        ],
    };
}

export function resolveDataViewerDefaultSortConfiguration(
    initialSortConfiguration: SortConfiguration | undefined,
): SortConfiguration {
    if (initialSortConfiguration !== undefined) {
        return initialSortConfiguration;
    }
    return buildDefaultCreatedAtSortConfiguration();
}

export function isDefaultDataViewerSortConfiguration(
    sortConfiguration: SortConfiguration,
    defaultSortConfiguration: SortConfiguration,
): boolean {
    if (sortConfiguration.lineItems.length !== defaultSortConfiguration.lineItems.length) {
        return false;
    }

    return sortConfiguration.lineItems.every((lineItem, index) => {
        const defaultLineItem = defaultSortConfiguration.lineItems[index];
        return (
            defaultLineItem !== undefined &&
            lineItem.columnId === defaultLineItem.columnId &&
            lineItem.direction === defaultLineItem.direction
        );
    });
}

/** Sort rules the user changed away from the module default (for badge / selected state). */
export function getUserAppliedSortRuleCount(
    sortConfiguration: SortConfiguration,
    defaultSortConfiguration: SortConfiguration,
): number {
    if (isDefaultDataViewerSortConfiguration(sortConfiguration, defaultSortConfiguration)) {
        return 0;
    }
    return sortConfiguration.lineItems.length;
}

/** Active sort badge count; by default treats the module default as active too. */
export function resolveSortActiveRuleCount({
    sortConfiguration,
    defaultSortConfiguration,
    showDefaultSortAsActive = true,
}: {
    sortConfiguration: SortConfiguration;
    defaultSortConfiguration: SortConfiguration;
    showDefaultSortAsActive?: boolean;
}): number {
    if (showDefaultSortAsActive === true) {
        return sortConfiguration.lineItems.length;
    }
    return getUserAppliedSortRuleCount(sortConfiguration, defaultSortConfiguration);
}
